import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table, TableBody, TableRow, TableCell, Typography, Container, Grid, Paper
} from '@material-ui/core';

import styles from './styles';

const useStyles = makeStyles(theme => (styles));

const ContactView = () => {

  const classes = useStyles();

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item sm={8} style={{margin: 'auto'}}>
          <Paper className={classes.panel}>
            <Typography>
              <h3>Contact</h3>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>Francesco Audrino</TableCell>
                    <TableCell>
                      <a href="https://mathstat.unisg.ch/en/personenverzeichnis/44d9e9b2-abce-4a28-8cc8-130dbd98fcb2">website</a>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Fabio Sigrist</TableCell>
                    <TableCell>
                      <a href="https://www.hslu.ch/en/lucerne-university-of-applied-sciences-and-arts/about-us/people-finder/profile/?pid=3064">website</a>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Daniele Ballinari</TableCell>
                    <TableCell>
                      <a href="https://mathstat.unisg.ch/en/personenverzeichnis/14860306-625e-43c9-8e79-6af0578ea67f">website</a></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Typography>
          </Paper>
          <Paper className={classes.panel}>
            <Typography>
            <h3>Funding</h3>
            The research project is funded by the Swiss National Science Foundation (Grant 100018-172685).
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ContactView;
